import { FormGroup } from "@angular/forms";

export class ClienteEditarUsuarioUtil {

  constructor(private form: FormGroup){}

  cpfMaskfn() {
    return [/[0-9]/, /\d/, /\d/, '.', /[0-9]/, /\d/, /\d/, '.', /[0-9]/, /\d/, /\d/, '-', /[0-9]/, /\d/,];
  }

  cpfValidate(param) {

    const val = param.replace(/[-.]/gi, "");

    if (
      val == null ||
      val.length < 11 ||
      val == "00000000000" ||
      val == "11111111111" ||
      val == "22222222222" ||
      val == "33333333333" ||
      val == "44444444444" ||
      val == "55555555555" ||
      val == "66666666666" ||
      val == "77777777777" ||
      val == "88888888888" ||
      val == "99999999999"
    ) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      return { invalid: true };
    }


    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(val.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(9))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      return { invalid: true };
    };
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(val.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(val.charAt(10))) {
      this.form.controls['cpf'].setErrors({ invalid: true });
      return { invalid: true };
    };
    this.form.controls['cpf'].setErrors(null);
    return { invalid: false };
  };

  date() {
    return [/[0-3]/, /[0-9]/, '/', /[0-1]/, /[0-9]/, '/', /[1-2]/, /([0|9])/, /[0-9]/, /[0-9]/]
  }
  
  // parse a date in yyyy-mm-dd format
  parseDate(input) {
    var parts = input.match(/(\d+)/g);
    // new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
    return new Date(parts[0], parts[1]-1, parts[2]); // months are 0-based
  }

  dateValidate(date) {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
      this.form.controls['birthDate'].setErrors({ invalid: true });
      return { invalid: true };
    }

    const validYear = new Date().getFullYear() - 18;

    const [d, m, y] = date.split('/')
    const day = d < 0 || d > 31 ? false : true;
    const month = m < 1 || m > 12 ? false : true;
    const year = y > validYear && parseInt(y, 10) < 1900 ? false : true;

    if (y < 1870) {
      this.form.controls['birthDate'].setErrors({ invalid: true });
      return { invalid: true };
    }

    if (!day || !month || !year) {
      this.form.controls['birthDate'].setErrors({ invalid: true });
      return { invalid: true };
    }

    this.form.controls['birthDate'].setErrors(null);
    return { invalid: false };

  }

  emailValidate(email) {
    if (!/\S+@\S+\.\S+/.test(email)) {
      this.form.controls['login'].setErrors({ invalid: true });
      return { invalid: true };
    }

    this.form.controls['login'].setErrors(null);
    return { invalid: false };
  };

  phoneMask() {
    return ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,]
  }

  phoneValidate(phone) {
    if (!/^[(]\d{2}[)]\d{5}-\d{4}/.test(phone)) {
      this.form.controls['fone'].setErrors({ invalid: true });
      return { invalid: true };
    }

    this.form.controls['fone'].setErrors(null);
    return { invalid: false };
  }

  validateNotSpecialCharacters(event: KeyboardEvent) {

    switch (event.keyCode) {
      case 8:  // Backspace
      case 9:  // Tab
      case 13: // Enter
      case 37: // Left
      case 38: // Up
      case 39: // Right
      case 40: // Down
        break;
      default:
        var regex = new RegExp("^[a-zA-Z0-9]+$");
        // var regex = new RegExp("^[a-zA-Z0-9.,/ $@()]+$");
        var key = event.key;
        if (!regex.test(key)) {
          event.preventDefault();
          return false;
        }
        break;
    }
  }

}
